<template>
  <div v-if="modelValue" class="camera">
    <div class="wrapper">
      <div class="modal-header">
        <h5 class="modal-title"> {{ tk_cusname }}
          ({{ $t("content.ticketno") }} : {{ tk_ref }}) </h5>
        <button type="button" class="btn button-close icon-only" @click="closedCamera">
          <i class="material-icons material-symbols-outlined fs-3">close</i>
        </button>
      </div>
      <pre></pre>
      <div class="container-fluid">
        <div class="row">
          
          <div class="col-lg-6">
            <fieldset>
              <div class="row">
                <div class="col-lg-12">
                  {{ $t("content.previmg") }} : {{ images.length }}
                </div>
              </div>
              <pre></pre>
              <div class="grid-containerP" v-if="images.length">
                <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                  <td>
                    <div class="wrapperP">
                      <figure :width="picWidth" :height="picHeight">
                        <img :src="item.src" class="img img-fluid" />
                      </figure>
                    </div>
                  </td>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="col-lg-6">
            <fieldset>
              <div class="row">
                <div class="col-lg-12">
                  {{ $t("content.takepic") }} {{ preview_list.length }}/5
                </div>
              </div>
              <pre></pre>
              <div class="grid-containerP" v-if="preview_list.length">
                <div v-for="item, index in preview_list" :key="index" class="d-inline-block mx-2">
                  <td>
                    <div class="wrapperP">
                      <figure :width="picWidth" :height="picHeight">
                        <img :src="item" class="img img-fluid" />
                      </figure>
                      <button type="button" class="btn myLayer" style="color: red;" :title="t('buttons.dele')"
                        @click="removeImage(item, index)">
                        <i i class="material-icons">close</i>
                      </button>
                    </div>
                  </td>
                </div>
              </div>
            </fieldset>
          </div>
          <hr />
          <div class="row">
            <div class="col-lg-6">
              <h5 class="mb-1">{{ $t("content.amntakephoto") }}</h5>
              <video v-show="isCameraOpen" class="camera-video" ref="cameraRef" :width="picWidth" :height="picHeight"
                autoplay playsinline></video>
            </div>
            <div class="col-lg-6">
              <h5 class="mb-1">{{ preview }}</h5>
              <canvas id="photoTaken" v-show="isPhotoTaken" class="canvas-photo" ref="canvasRef" :width="picWidth"
                :height="picHeight">
              </canvas>
            </div>
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-3 d-flex justify-content-between align-items-center">
            <button v-if="image_list.length > 0" class="d-block btn btn-info btn mx-2" @click="saveImage">
              <i class="material-icons material-symbols-outlined">save</i>
              {{ save }}
            </button>
          </div>
          <div class="col-9 d-flex justify-content-end align-items-center">
            <button v-if="!isPhotoTaken && isCameraOpen" type="button" class="d-block btn btn-primary btn mx-2"
              @click="takePhoto" :disabled="image_list.length >= 5">
              <i class="material-icons material-symbols-outlined">photo_camera</i>
              {{ take }}
            </button>

            <button v-if="isPhotoTaken && isCameraOpen" type="button" class="d-block btn btn-warning btn mx-2"
              @click="takePhoto" :disabled="image_list.length >= 5">
              <i class="material-icons material-symbols-outlined">cached</i>
              {{ retake }}
            </button>

            <button v-if="isPhotoTaken && isCameraOpen" class="d-block btn btn-dark btn mx-2" @click="takeImage"
              :disabled="image_list.length >= 5">
              <i class="material-icons material-symbols-outlined">done_all</i>
              {{ confirm }}
            </button>




          </div>
        </div>

        <!-- <div class="row mt-3">
          <div class="col-12 d-flex justify-content-end align-items-center">
            <material-button v-if="!isPhotoTaken && isCameraOpen" color="danger"
              class="float-lg-start float-sm-end mb-3 mx-2" @click="takePhoto" :disabled="image_list.length >= 5">
              <i class="material-icons material-symbols-outlined">add_a_photo</i>
              {{ take }}
            </material-button>

            <material-button v-if="!isPhotoTaken && isCameraOpen" id="capImage" color="primary"
              class="float-lg-start float-sm-end mb-3 mx-2" :disabled="image_list.length >= 5" @click="takePhoto">
              <i class="material-icons material-symbols-outlined">add_a_photo</i>
              {{ retake }}
            </material-button>

            <material-button v-if="!isPhotoTaken && isCameraOpen" id="capImage" color="primary"
              class="float-lg-start float-sm-end mb-3" :disabled="image_list.length >= 5" @click="takeImage">
              <i class="material-icons material-symbols-outlined">add_a_photo</i>
              {{ confirm }}
            </material-button>

            <material-button v-if="image_list.length > 0" color="default" class="float-lg-start float-sm-end mb-3 mx-2"
              @click="saveImage">
              <i class="material-icons material-symbols-outlined">close</i>
              {{ save }}
            </material-button>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script setup>
// onMounted, onBeforeUnmount, toRefs
/* eslint-disable no-unused-vars */
import { ref, computed, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import moment from 'moment'
import MaterialButton from "@/components/MaterialButton.vue";

const { t } = useI18n();

const cameraRef = ref("cameraRef");
const canvasRef = ref("canvasRef");

const isCameraOpen = ref(false);
const isPhotoTaken = ref(false);

const picWidth = ref(400);
const picHeight = ref(300);

const photoFile = ref(null);

const images = ref([]);
const tk_ref = ref("");
const tk_cusname = ref("");

const preview_list = ref([]);
const image_list = ref([]);

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
    required: true,
  },
  deviceId: {
    type: String,
    default: "",
  },
  cameras: {
    type: Array,
    default: () => [],
  },
  isInit: {
    type: Boolean,
    default: false,
  },
});
const { modelValue } = toRefs(props);

const emit = defineEmits([
  "close:modelValue",
  "clear",
  "stop",
  "start",
  "pause",
  "resume",
  "error",
  "unsupported",
  "init",
  "photoTaken",
  "save",
  "download",
]);

///// computed
// const close = computed(() => t("buttons.closecam"));
// const open = computed(() => t("buttons.opencam"));
const preview = computed(() => t("buttons.preview"));
const save = computed(() => t("buttons.save"));
const take = computed(() => t("buttons.takePhoto"));
const retake = computed(() => t("buttons.retakePhoto"));
const confirm = computed(() => t("buttons.conf"));

const closedCamera = () => {
  isCameraOpen.value = false;
  isPhotoTaken.value = false;
  isCameraOpen.value ? stopCameraStream() : null;
  // console.log("closed");
  emit("close");
};

const startCameraStream = () => {
  const constraints = (window.constraints = {
    audio: false,
    video: true ?? {
      facingMode: {
        exact: "environment",
      },
    },
  });

  navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      cameraRef.value.srcObject = stream;
    })
    .catch((error) => {
      alert(error, "May the browser didn't support or there is some errors.");
    });
};

const stopCameraStream = () => {
  //cameraRef.value.srcObject.getVideoTracks()[0].stop();
  const tracks = cameraRef.value.srcObject.getTracks().stop();

  tracks.forEach((track) => {
    track.stop();
    cameraRef.value.srcObject = null;
    cameraRef.value.source = null;
    cameraRef.value.srcObject.getVideoTracks()[0].stop();
  });

  console.log("CameraClosed");
};

const callStartCamera = () => {
  isCameraOpen.value = true;
  if (localStorage.getItem("imageL") !== null) {
    images.value = JSON.parse(localStorage.getItem("imageL"));
  }

  if (localStorage.getItem("dataL") !== null) {
    let dtL = JSON.parse(localStorage.getItem("dataL"));
    if (dtL.length > 0) {
      tk_ref.value = dtL[0].refnumber;
      tk_cusname.value = dtL[0].cusnameTh;
    }
  }
  startCameraStream();
};

callStartCamera();

const takePhoto = () => {
  photoFile.value = null
  isPhotoTaken.value = !isPhotoTaken.value;

  const context = canvasRef.value.getContext("2d");
  const photoFromVideo = cameraRef.value;

  context.drawImage(photoFromVideo, 0, 0, picWidth.value, picHeight.value);

  const image_data_url = document
    .getElementById("photoTaken")
    .toDataURL("image/jpeg")
  photoFile.value = image_data_url
  emit("photoTaken");
};




const takeImage = () => {
  let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
  let thumb_name = 'ticketimg_' + today + '.jpg'
  preview_list.value.push(photoFile.value);
  image_list.value.push({ filedt: photoFile.value, fname: thumb_name, ftype: "image/jpeg" })
  takePhoto()
};


const saveImage = () => {
  isCameraOpen.value = false;
  isPhotoTaken.value = false;
  isCameraOpen.value ? stopCameraStream() : null;
  emit("save", image_list.value);
};

const removeImage = (image, index) => {
  preview_list.value.splice(index, 1);
  image_list.value.splice(index, 1);
}

</script>

<style lang="scss" scoped>
.camera {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
}

.wrapper {
  position: relative;
  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  width: 80%;
  min-height: 520px;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
}

button {
  cursor: pointer;
}

.button-open {
  position: absolute;
  bottom: 25px;
  right: 50px;
}

.button-close {
  position: absolute;
  top: 25px;
  right: 10px;
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr
}

.wrapperP {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}
</style>
